<button mat-flat-button type="submit" [disabled]="isLoading"
  [ngClass]="{
  'w-full': isFullWidth,
  'tk-bg-blue tk-bg-blue-dark-hover': isActive,
  'tk-bg-gray-4 tk-btn-gray-hover': !isActive}"
  class="flex justify-center items-center font-normal hover:font-normal" appPreventDoubleClick
  (throttledClick)="onClick()" [throttleTime]="700">
  <div *ngIf="!isLoading" class="text-white" [ngClass]="innerTextClasses">{{label}}</div>
  <div *ngIf="isLoading" class="flex justify-center items-center is-loading" [ngClass]="spinnerClasses">
    <mat-spinner [strokeWidth]="2" [diameter]="24"></mat-spinner>
  </div>
</button>
